import React from 'react';
import PropTypes from "prop-types";

export const RenderCartConstrButtons = ({sizes, addToCart, redirectToConstructor}) => {
  const [clicked, setClicked] = React.useState(false);
  const [valid, setValid] = React.useState(true);

  React.useEffect(() => {
    if (clicked) setValid(sizes);
  });

  const addToCartCheck = () => {
    if (!clicked) setClicked(true);
 
    if(!sizes) {
      setValid(false);
    } else {
      setValid(true);
      addToCart();
    }
  }

  return (
      <div className="b-rit-product-page__button-block">
          {valid ?
            <button
                className="rit-button rit-button_theme_black"
                onClick={addToCartCheck}
              >
                В корзину
            </button>                
            :    
            <button 
                className="rit-button rit-button_theme_red"
                onClick={addToCartCheck}>
                Пожалуйста выберите размер
            </button>   
          }
          <button
              className="rit-button rit-button_theme_gray"
              onClick={redirectToConstructor}
              >
              Загрузить в конструктор
          </button>
      </div>
  )
}

RenderCartConstrButtons.propTypes = {
  sizes: PropTypes.object,
  addToCart: PropTypes.func.isRequired,
  redirectToConstructor: PropTypes.func.isRequired
}